export default __webpack_public_path__ + "static/media/ragazo-mais.35a9fe70.svg";